import React from "react";
import { Container, Col } from "react-bootstrap";

const fixed = {
  backgroundImage: `url('https://res.cloudinary.com/universitytix/image/upload/v1600942280/VC_h3fg11.png')`,
};


function Visits() {
  return (
    <div>

<div id="resources" className="offset">
        <div className="fixed-background">
          <div className="row dark text-center ">
            <Col sm="12">
              <br />
              <br />
              <br />
              <br />
              <br />
              <h3 className="heading headers">Research/Study Visits</h3>

              <br />
              <br />
              <br />
              <br />
              <div className="heading-underline"></div>
            </Col>
          </div>

          <div className="fixed-wrap">
            <div className="fixed" style={fixed}></div>
          </div>
        </div>
      </div>

      <br />
      <br />
      <br />
      <br />
      <Container>
          <li>Research Visit as Research Scientist to the International Centre for Theoretical Physics (ICTP) Trieste, Italy, August – September, 1992</li>
          <br />
          <li>Research Visit as Research Scientist to the International Centre for Theoretical Physics (ICTP) Trieste, Italy, November, 2001</li>
          <br />
          <li>Research Visit as Research Scientist to the International Centre for Theoretical Physics (ICTP) Trieste, Italy, Sept. – Nov. 2007</li>
          <br />
          <li>Research Visit as Research Scientist to the University of Trieste, Italy, Oct. – Nov. 2007</li>
          <br />
          <li>Research Visit as Research Scientist to the International Centre for   Theoretical Physics (ICTP) Trieste, Italy,  Nov. 2009</li>
          <br />
          <li>Research Visit as Research Associate to the Institute of Environmental Physics, Environmental   Radioactivity Laboratory, University of Bremen,Germany,  October 2007</li>
          <br />
          <li>Research Visit as Research Associate to the Institute of Environmental Physics, Environmental Radioactivity Laboratory, University of Bremen, Germany,  June-July 2006</li>
          <br />
          <li>Research Visit as Senior Lecturer, Institute of Environmental Physics,Environmental   Radioactivity Laboratory, University of Bremen, Germany,  April-July, 2005</li>
          <br />
          <li>Study Visits to Kwame Nkrumah University of Science & Technology(NKNUST), Kumasi, University of Capetown and University of Legon, Ghana, 2003</li>
          <br />
          <li>Study Visits to Haifa University, Ben Gurion University, the Hebrew University, Jerusalem and the Open University, Ra’anana all in Israel in January, 2012</li>
          <br />
          <li>Study Visit to Kenyatta University Campus in Mombasa, Kenya in 2010</li>
          <br />
          <li>Study Visits to Aberdeen University and Robert Gordon University in Aberdeen, UK in 2012</li>
          <br />
          <li>Study Visits to the Maryland University, Baltimore, Morgan State University, and John Hopkins University, Baltimore, USA in July 2010</li>
          <br />
          <li>Study Visit to Pittsburg State University, Pittsburg, Kansas, USA in July 2011</li>
          <br />
          <li>Study Visit to University of Johannesburg, South Africa, 24th – 28th March, 2014</li>
          <br />
          <li>16.Study Visit to Windhoek, Namibia, 19th - 23rd September, 2018.</li>
          <br />
          <br />
          <br />

      </Container>
    </div>
  );
}
export default Visits;
